<mat-card>
  <button mat-button color="primary" (click)="addNewFilter()" [disabled]="!canAddFilter()">
    + Add filter
  </button>
  <app-rule-filter *ngFor="let filter of getRuleFilters()" [filter]="filter"> </app-rule-filter>
</mat-card>
